import { FC } from 'react';
import { Route, Routes } from 'react-router-dom';
import NotFound from 'pages/not-found';
import MentorshipPage from './MentorshipPage';
import Interviews from './interviews';

const MentorshipManagementRoutes: FC = () => {
  return (
    <Routes>
      <Route path="/" element={<MentorshipPage />} />
      <Route path="/interviews" element={<Interviews />} />
      <Route path="/*" element={<NotFound />} />
    </Routes>
  );
};

export default MentorshipManagementRoutes;
